import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { PlatformDataService } from '../../services/platform-data';

/**
 * HTTP Interceptor function for Server-Side Rendering (SSR).
 * It retrieves all cookies via SsrCookieService.getAll() and constructs the 
 * raw 'Cookie' header string to attach to outgoing requests when 'withCredentials: true' is set.
 */
export const serverCredentialsInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const platformDataService = inject(PlatformDataService);
  const cookieService = inject(SsrCookieService, { optional: true });

  // 1. Skip when in browser or credentials not required or request is external
  if (platformDataService.isBrowser || !req.withCredentials || !req.url.includes('/ml-bff')) {
    return next(req);
  }

  // 2. Retrieve all cookies.
  const allCookies = cookieService?.getAll();

  if (allCookies && Object.keys(allCookies).length > 0) {
    // 3. Build the raw Cookie header.
    const rawCookieHeader = Object.entries(allCookies)
      .map(([key, value]) => `${key}=${value}`)
      .join('; ');

    // 4. Clone the request and **append** the Cookie header.
    const clonedRequest = req.clone({
      withCredentials: true,
      headers: req.headers.append('Cookie', rawCookieHeader)
    });

    // 5. Send the modified request
    return next(clonedRequest);
  }

  return next(req);
};
